import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConferenceFormComponent } from './conference-form.component';

const routes: Routes = [
  { path: '', component: ConferenceFormComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConferenceFormRoutingModule { }
